export const ARTICLES = [
  {
    slug: "industrial-construction-programme-certainty",
    title: "Building Programme Certainty into Industrial Construction",
    category: "Industry Insights",
    excerpt: "Programme slippage on industrial projects is rarely caused by one large event. It accumulates through decisions made long before mobilisation.",
    author: "MAXEK INFRA",
    published_on: "2025-11-18",
    read_minutes: 6,
    image: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["Industrial Construction", "Project Management", "Programme"],
    related_vertical: "maxek-infra",
    related_industry: "Industrial",
    body: [
      { type: "paragraph", text: "Industrial projects are judged on a single question: was the facility ready when production needed it? Everything else is secondary to that date." },
      { type: "heading", text: "Slippage is cumulative, not sudden" },
      { type: "paragraph", text: "Programmes usually lose time through a series of small deferrals that consume the float protecting commissioning." },
      { type: "list", items: ["Fix interface points early.", "Move weather-sensitive work off the critical path.", "Sequence independent zones for concurrent work.", "Review every contractor against one shared look-ahead."] },
    ],
  },
  {
    slug: "erp-implementation-manufacturing-what-matters",
    title: "ERP Implementation for Manufacturing: What Actually Determines Success",
    category: "Technology Updates",
    excerpt: "Most ERP programmes are not undone by software limitations. They are undone by master data, process ambiguity and adoption.",
    author: "MAXEK SOLUTIONS",
    published_on: "2025-11-04",
    read_minutes: 7,
    image: "https://images.unsplash.com/photo-1763038311036-6d18805537e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["ERP", "Manufacturing", "Digital Transformation"],
    related_vertical: "maxek-solutions",
    related_industry: "Manufacturing",
    body: [
      { type: "paragraph", text: "Manufacturing organisations usually evaluate ERP platforms on feature comparison. In practice, the platform is rarely the deciding factor." },
      { type: "heading", text: "Master data comes before configuration" },
      { type: "paragraph", text: "Duplicate codes, inconsistent units and overlapping vendor records reproduce themselves inside a new system unless they are corrected first." },
      { type: "list", items: ["Cleanse master data before configuration.", "Document the real operating process.", "Train each team by role.", "Plan a controlled production cutover."] },
    ],
  },
  {
    slug: "ai-solutions-for-industrial-businesses",
    title: "Where AI Genuinely Helps Industrial Businesses Today",
    category: "Articles",
    excerpt: "Beyond the discourse, there are specific industrial problems where applied AI already delivers measurable operational value.",
    author: "MAXEK SOLUTIONS",
    published_on: "2025-10-21",
    read_minutes: 6,
    image: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["AI Solutions", "Industrial Technology", "Data Analytics"],
    related_vertical: "maxek-solutions",
    related_industry: "Technology",
    body: [
      { type: "paragraph", text: "The useful question for an industrial business is which recurring decisions are currently made with incomplete information." },
      { type: "heading", text: "Problems that suit applied AI" },
      { type: "list", items: ["Early warning on project variance.", "Quality-event classification.", "Demand and consumption forecasting.", "Document and drawing interrogation."] },
      { type: "paragraph", text: "Start with one decision, improve the data behind it, and measure whether the outcome improves." },
    ],
  },
  {
    slug: "steel-fabrication-quality-control",
    title: "Quality Control in Steel Fabrication: From Shop to Erection",
    category: "Case Studies",
    excerpt: "Tolerance is decided in the shop, not on site. A look at the control points that determine whether steel erects first time.",
    author: "MAXEK INFRA",
    published_on: "2025-10-07",
    read_minutes: 5,
    image: "https://images.unsplash.com/photo-1698664683348-f9f35b809821?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["Steel Fabrication", "Structural Engineering", "Quality"],
    related_vertical: "maxek-infra",
    related_industry: "Industrial",
    body: [
      { type: "paragraph", text: "When structural steel does not fit on site, the cause is almost always upstream. Erection reveals decisions already taken in the fabrication shop." },
      { type: "heading", text: "Control points that matter" },
      { type: "list", items: ["Verify shop drawings against the coordinated model.", "Maintain material traceability.", "Inspect dimensions before coating.", "Use survey-controlled erection."] },
    ],
  },
  {
    slug: "digital-engineering-factory-infrastructure",
    title: "Digital Engineering in Factory Infrastructure Projects",
    category: "Industry Insights",
    excerpt: "Coordinated models and structured data reduce rework on factory projects more reliably than additional site supervision.",
    author: "MAXEK",
    published_on: "2025-09-23",
    read_minutes: 6,
    image: "https://images.unsplash.com/photo-1767294274634-613a3545e36d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["Digital Engineering", "Factory Infrastructure", "Innovation"],
    related_vertical: "maxek-solutions",
    related_industry: "Manufacturing",
    body: [
      { type: "paragraph", text: "Factory projects are dense with interfaces between structure, equipment, utilities and safety systems." },
      { type: "heading", text: "Resolve clashes where they are inexpensive" },
      { type: "paragraph", text: "A coordinated model moves clash resolution from the site to the desk, reducing rework and delay." },
      { type: "list", items: ["Model-linked as-built records.", "Asset data captured at installation.", "Traceable change history."] },
    ],
  },
  {
    slug: "business-growth-frameworks-for-smes",
    title: "Structuring Growth: Frameworks That Work for Indian SMEs",
    category: "Articles",
    excerpt: "Growth stalls when informal processes that worked at ten people are still in use at a hundred.",
    author: "MAXEK BUSINESS HUB",
    published_on: "2025-09-09",
    read_minutes: 5,
    image: "https://images.unsplash.com/photo-1758518730083-4c12527b6742?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["Business Growth", "Business Systems", "Strategy"],
    related_vertical: "maxek-business-hub",
    related_industry: "Commercial",
    body: [
      { type: "paragraph", text: "Most SMEs do not stall because demand disappears. They stall because informal coordination cannot carry the next stage of growth." },
      { type: "heading", text: "Systemise before scaling" },
      { type: "paragraph", text: "Documenting the operating standard before automating repetitive work means growth adds volume rather than chaos." },
      { type: "list", items: ["Create repeatable acquisition channels.", "Document delivery standards.", "Automate management reporting."] },
    ],
  },
  {
    slug: "maxek-corporate-profile-download",
    title: "MAXEK Corporate Profile",
    category: "Downloads",
    excerpt: "An overview of MAXEK India Private Limited, our three business verticals, capabilities and engineering approach.",
    author: "MAXEK",
    published_on: "2025-08-26",
    read_minutes: 2,
    image: "https://images.unsplash.com/photo-1690944851207-3f288c8fcd0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["Corporate Profile", "MAXEK", "Downloads"],
    download_url: "request",
    body: [
      { type: "paragraph", text: "The MAXEK Corporate Profile summarises our organisation, business verticals, capabilities and engineering approach." },
      { type: "heading", text: "What the profile covers" },
      { type: "list", items: ["Company overview and structure.", "Engineering and industrial execution capabilities.", "Technology and digital engineering capabilities.", "Business growth ecosystem."] },
    ],
  },
  {
    slug: "maxek-media-and-announcements",
    title: "MAXEK Media & Announcements",
    category: "Media",
    excerpt: "Official announcements, media resources and brand assets relating to MAXEK India Private Limited.",
    author: "MAXEK",
    published_on: "2025-08-12",
    read_minutes: 2,
    image: "https://images.unsplash.com/photo-1686676104932-3d7b6bbaef52?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tags: ["Media", "MAXEK", "Announcements"],
    body: [
      { type: "paragraph", text: "This section carries official MAXEK announcements and media resources." },
      { type: "heading", text: "Media enquiries" },
      { type: "list", items: ["Email: info@maxekindia.com", "Telephone: +91 9666822000", "Registered office: Singapore Plaza, Pattom Palace, Thiruvananthapuram."] },
    ],
  },
];
